
(function ($) {
	'use strict';
	var quickExit = {
		el: '.tasg-quick-exit',
		init: function init() {
			this.methods();
		},
		methods: function methods() {
			var newloc = 'https://www.google.com.au';
			var el = $(this.el);
			if (el.length > 0) {
				// IE 11 fix
				/*global Stickyfill*/
				Stickyfill.add(el);
				// navigating on pressing Escape key
				$(document).keydown(function (e) {
					if (e.keyCode === 27) {
						window.open(newloc, '_blank', '');
						window.location.replace(newloc);
						return false;
					}
				});
				// clicking on the quick exit button
				$('body').on('click', '.tasg-quick-exit__button', function () {
					window.open(newloc, '_blank', '');
					window.location.replace(newloc);
				});
			}
		} };

		quickExit.init();

	}(jQuery));
